const exampleResultItem = {
  career_level: ["professional"],
  company: "Dynava",
  coordinate: [50.935173, 6.953101],
  department: ["Legal"],
  external_id: "14524",
  id: "358",
  location: ["Obikiik", "Cologne"],
  location_count: 2,
  full_address: [
    "Main Street 42, 12345 Obikiik",
    "Venloer Straße 601, 50827 Cologne",
  ],
  salary: 85221,
  schedule: ["Part-time"],
  start_date: "02.08.2024",
  start_date_timestamp: 1763451921,
  start_year: 2024,
  title: "Desktop Support Technician",
  work_mode: ["on-site"],
  working_hours: ["20 hours / week"],
  url: "https://example.com/job",
};

export default exampleResultItem;
